<template>
  <section class="views" @click="schoolNameList = []">
    <!-- header -->
    <headers select="-1"></headers>

    <!-- banner  -->
    <div class="posters">
      <van-image
        width="100%"
        :src="require('@/assets/image/hodgepodge/pcbanner.jpg')"
      />
      <div class="posters_ewm">
        <div class="ewm" @click="whatapp()">
          <div class="ewm2">
            <div class="ewm3">
              <img :src="require('@/assets/image/hodgepodge/ewm.png')" alt="" />
            </div>
            <div class="ewm3_value">
              <img :src="require('@/assets/image/wa.png')" alt="" /> 人工諮詢
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- from -->
    <div class="content">
      <div class="contentFrom_titleBox">
        <!-- <div class="contentFrom_title">參賽方式</div> -->
        <div class="contentFrom_title">在線報名</div>
        <!-- 報名資料 -->
      </div>
      <!-- 个人&团体 -->
      <div class="type_container" v-if="!signUp_type && step == 1">
        <div class="competition_type" @click="handleStep()">
          <img :src="require('@/assets/image/icon/geren.png')" alt="" />
          <div>個人賽</div>
        </div>
        <div class="competition_type" @click="handleStep(1)">
          <img :src="require('@/assets/image/icon/tuanti.png')" alt="" />
          <div>團體賽</div>
        </div>
      </div>
      <!-- 个人&学校 -->
      <div class="type_container" v-if="!signUp_type && step == 2">
        <div class="competition_type" @click="handleStep(2)">
          <img :src="require('@/assets/image/icon/geren.png')" alt="" />
          <div>個人賽</div>
        </div>
        <div class="competition_type" @click="handleStep(3)">
          <img :src="require('@/assets/image/icon/school.png')" alt="" />
          <div>學校统一報名</div>
        </div>
      </div>
      <div class="contentFrom_uls" v-if="signUp_type == 1">
        <ul>
          <li>
            <div class="list">
              <div class="listLeft">参赛團體/機構</div>
              <div class="listRight listPan" style="display: flex">
                <input
                  type="text"
                  placeholder="請輸入正確的團體/機構中文全稱"
                  v-model.trim="from.agencyName"
                />
              </div>
            </div>
          </li>
          <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">聯絡人姓名</div>
                <div class="listRight">
                  <input
                    type="text"
                    placeholder="請輸入姓名"
                    v-model.trim="from.personInChargeName"
                  />
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="list">
              <div class="listLeft">聯絡人電話</div>
              <div class="listRight">
                <div class="listRight_sji">
                  <div class="left" style="cursor: pointer">
                    <van-popover
                      v-model="mobilePhoneActionsShow"
                      placement="bottom"
                      trigger="click"
                      :actions="mobilePhoneActions"
                      @select="onmobilePhoneSelect"
                    >
                      <template #reference>
                        <div
                          class="promptInputValue"
                          :class="gradeIndex == -1 ? '' : 'placeholderValue'"
                        >
                          {{ from.code }}
                          <span
                            :class="{ '': true, left_formTwo: showPickerTwo }"
                          >
                            <van-icon
                              name="arrow-down"
                              size="12"
                              color="#333333"
                            />
                          </span>
                        </div>
                      </template>
                    </van-popover>
                  </div>

                  <div class="right">
                    <input
                      type="number"
                      placeholder="請輸入手機號"
                      v-model.trim="from.personInChargePhone"
                    />
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li>
            <div class="list">
              <div class="listLeft">驗證碼</div>
              <div class="listRight">
                <div class="listRight_sji2">
                  <div class="right">
                    <input
                      type="text"
                      placeholder="請輸入驗證碼"
                      v-model.trim="from.verifyCode"
                    />
                  </div>
                  <div
                    class="right2"
                    @click="CodeBln ? clickNumberCodeFnc() : ''"
                    v-html="codeMsg"
                  ></div>
                </div>
              </div>
            </div>
          </li>

          <li>
            <div class="list">
              <div class="listLeft">電郵</div>
              <div class="listRight" style="display: flex">
                <input
                  type="text"
                  placeholder="請輸入電郵"
                  v-model.trim="from.personInChargeEmail"
                />
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="contentFrom_uls" v-if="signUp_type == 2">
        <ul>
          <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">參賽者姓名</div>
                <div class="listRight">
                  <input
                    type="text"
                    placeholder="請輸入參賽者姓名"
                    v-model.trim="from.username"
                  />
                </div>
              </div>
              <div class="beizhu_2">*須與身份證上的姓名一致</div>
            </div>
          </li>
          <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">手機號</div>
                <div class="listRight">
                  <div class="listRight_sji">
                    <div class="left" style="cursor: pointer">
                      <van-popover
                        v-model="mobilePhoneActionsShow"
                        placement="bottom"
                        trigger="click"
                        :actions="mobilePhoneActions"
                        @select="onmobilePhoneSelect"
                      >
                        <template #reference>
                          <div
                            class="promptInputValue"
                            :class="gradeIndex == -1 ? '' : 'placeholderValue'"
                          >
                            {{ from.code }}
                            <span
                              :class="{ '': true, left_formTwo: showPickerTwo }"
                            >
                              <van-icon
                                name="arrow-down"
                                size="12"
                                color="#333333"
                              />
                            </span>
                          </div>
                        </template>
                      </van-popover>
                    </div>

                    <div class="right">
                      <input
                        type="number"
                        placeholder="請輸入手機號碼"
                        v-model.trim="from.personInChargePhone"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="schoolCode" class="beizhu">
                *此號碼僅接收比賽通知，不可登錄App
              </div>
            </div>
          </li>
          <template v-if="!schoolCode">
            <li>
              <div class="list">
                <div class="listLeft">手機驗證碼</div>
                <div class="listRight">
                  <div class="listRight_sji2">
                    <div class="right">
                      <input
                        type="text"
                        placeholder="請輸入驗證碼"
                        v-model.trim="from.verifyCode"
                      />
                    </div>
                    <div
                      class="right2"
                      @click="CodeBln ? clickNumberCodeFnc() : ''"
                      v-html="codeMsg"
                    ></div>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="list">
                <div class="listLeft">電郵</div>
                <div class="listRight" style="display: flex">
                  <input
                    type="text"
                    placeholder="請輸入參賽者電郵"
                    v-model.trim="from.personInChargeEmail"
                  />
                </div>
              </div>
            </li>
          </template>
          <template v-if="schoolCode">
            <li>
              <div class="list2">
                <div class="list2_uls">
                  <div class="listLeft">學生編號</div>
                  <div class="listRight" style="display: flex">
                    <input
                      type="text"
                      placeholder="請輸入學生編號"
                      v-model.trim="from.studentCode"
                    />
                  </div>
                </div>
                <div class="beizhu">*僅用於登錄App，可自定義數字或英文字母</div>
              </div>
            </li>
            <li>
              <div class="list2">
                <div class="list2_uls">
                  <div class="listLeft">登錄密碼</div>
                  <div class="listRight">
                    <input
                      type="text"
                      placeholder="請輸入登錄密碼"
                      v-model.trim="from.password"
                    />
                  </div>
                </div>
                <div class="beizhu">*僅用於登錄App，可自定義數字或英文字母</div>
              </div>
            </li>
          </template>
          <li>
            <div class="list">
              <div class="listLeft">性别</div>
              <div class="listRight">
                <!-- @click="sexBut" -->
                <div class="listRight_xuan">
                  <!-- 	<span :class="
                      from.sex == '請選擇參賽者性别' ? '' : 'placeholderValue'
                    ">{{ this.from.sex }}</span>
									<span class="listRight_icon"
										:class="{ '': true, listRight_icontransform: showPicker }">
										<van-icon name="arrow-down" size="12" color="#333333" />
									</span>
									 -->

                  <van-popover
                    v-model="showSexPopover"
                    trigger="click"
                    :actions="sexActions"
                    @select="onSexSelect"
                  >
                    <template #reference>
                      <div
                        class="promptInputValue"
                        :class="sexIndex == -1 ? '' : 'placeholderValue'"
                      >
                        {{ from.sex }}
                      </div>
                    </template>
                  </van-popover>
                </div>
              </div>
            </div>
          </li>

          <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">年級</div>
                <div class="listRight">
                  <div class="listRight_xuan" @click.stop="schoolBut">
                    <span
                      :class="
                        from.grade !== '選擇參賽者年級'
                          ? 'placeholderValue'
                          : ''
                      "
                    >
                      {{ from.grade }}
                    </span>
                    <span class="listRight_icon">
                      <van-icon name="arrow-down" size="12" color="#333333" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <!-- 新增：組別（展示與選擇第二級） -->
          <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">組別</div>
                <div class="listRight">
                  <div class="listRight_xuan" @click.stop="openGroupPicker">
                    <span :class="competitionGroup ? 'placeholderValue' : ''">
                      {{ competitionGroup || "請選擇組別" }}
                    </span>
                    <span class="listRight_icon">
                      <van-icon name="arrow-down" size="12" color="#333333" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li>
            <div class="list">
              <div class="listLeft">學校所在地區</div>
              <div class="listRight">
                <div
                  v-if="!schoolCode"
                  class="listRight_xuan"
                  @click.stop="toggleElement"
                >
                  <span
                    :class="newAddress.length == 0 ? '' : 'placeholderValue'"
                    v-if="newAddress.length != 0"
                    >{{ newAddress[0] }}>{{ newAddress[1] }}</span
                  >
                  <span v-else>請選擇地區</span>
                </div>
                <div v-if="schoolCode" class="listRight_xuan_2">
                  <span
                    :class="newAddress.length == 0 ? '' : 'placeholderValue'"
                    v-if="newAddress.length != 0"
                    >{{ newAddress[0] }}>{{ newAddress[1] }}</span
                  >
                  <span v-else>請選擇地區</span>
                </div>

                <div class="selectBox" v-if="showPickerschool" ref="elementDQ">
                  <div class="selectBoxLeft">
                    <div class="selectBox_uls">
                      <div
                        class="selectBox_lis"
                        v-for="(item, index) in diquaddRess"
                        :key="index"
                        :class="dqiSelectIndex == index ? 'select_select' : ''"
                        @click="onselectDqBut(item, index)"
                      >
                        {{ item.title }}
                      </div>
                    </div>
                  </div>
                  <div class="selectBox_xian"></div>
                  <div class="selectBoxRight">
                    <div class="selectBox_uls">
                      <div
                        class="selectBox_lis"
                        v-for="(item, index) in diquaddRess2"
                        :key="index"
                        :class="dqiSelectIndex2 == index ? 'select_select' : ''"
                        @click="onselectDqBut2(item, index)"
                      >
                        {{ item }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li>
            <div class="list">
              <div class="listLeft">就讀學校</div>
              <div class="listRight listPan" style="display: flex">
                <input
                  v-if="!schoolCode"
                  type="text"
                  placeholder="請輸入參賽者就讀學校"
                  v-model.trim="searchCampus"
                  @click.stop="getHkSchoolList()"
                />
                <input
                  v-if="schoolCode"
                  type="text"
                  placeholder="請輸入參賽者就讀學校"
                  :value="`${searchCampus} ${schoolCode}`"
                  disabled
                  style="cursor: not-allowed"
                />

                <div class="posText" v-if="schoolNameList.length != 0">
                  <ul>
                    <li
                      v-for="(item, index) in schoolNameList"
                      :key="index"
                      @click.stop="zhiyin(item)"
                      style="font-size: 14px"
                    >
                      {{ item.schoolName }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="beizhu_2">請注意：請勿輸入中/英文縮寫</div>
          </li>
        </ul>
        <div class="school-tip">
          <span class="school-tip__link" @click.stop="goToSchoolInfo">
            學校 / 機構 請點擊登記【學校信息】
          </span>
        </div>
      </div>
      <div class="contentFrom_uls" v-if="signUp_type == 3">
        <ul>
          <li>
            <div class="list">
              <div class="listLeft">學校所在地區</div>
              <div class="listRight">
                <div class="listRight_xuan" @click.stop="toggleElement">
                  <span
                    :class="newAddress.length == 0 ? '' : 'placeholderValue'"
                    v-if="newAddress.length != 0"
                    >{{ newAddress[0] }}>{{ newAddress[1] }}</span
                  >
                  <span v-else>請選擇地區</span>
                </div>

                <div class="selectBox" v-if="showPickerschool" ref="elementDQ">
                  <div class="selectBoxLeft">
                    <div class="selectBox_uls">
                      <div
                        class="selectBox_lis"
                        v-for="(item, index) in diquaddRess"
                        :key="index"
                        :class="dqiSelectIndex == index ? 'select_select' : ''"
                        @click="onselectDqBut(item, index)"
                      >
                        {{ item.title }}
                      </div>
                    </div>
                  </div>
                  <div class="selectBox_xian"></div>
                  <div class="selectBoxRight">
                    <div class="selectBox_uls">
                      <div
                        class="selectBox_lis"
                        v-for="(item, index) in diquaddRess2"
                        :key="index"
                        :class="dqiSelectIndex2 == index ? 'select_select' : ''"
                        @click="onselectDqBut2(item, index)"
                      >
                        {{ item }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li>
            <div class="list">
              <div class="listLeft">參賽學校</div>
              <div class="listRight listPan" style="display: flex">
                <input
                  type="text"
                  placeholder="請輸入參賽學校"
                  v-model.trim="searchCampus"
                />

                <div class="posText" v-if="schoolNameList.length != 0">
                  <ul>
                    <li
                      v-for="(item, index) in schoolNameList"
                      :key="index"
                      @click="zhiyin(item)"
                      style="font-size: 14px"
                    >
                      {{ item.schoolName }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">學校聯絡人姓名</div>
                <div class="listRight">
                  <input
                    type="text"
                    placeholder="請輸入聯絡人姓名"
                    v-model.trim="from.personInChargeName"
                  />
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="list">
              <div class="listLeft">學校聯絡人電話</div>
              <div class="listRight">
                <div class="listRight_sji">
                  <div class="left" style="cursor: pointer">
                    <van-popover
                      v-model="mobilePhoneActionsShow"
                      placement="bottom"
                      trigger="click"
                      :actions="mobilePhoneActions"
                      @select="onmobilePhoneSelect"
                    >
                      <template #reference>
                        <div
                          class="promptInputValue"
                          :class="gradeIndex == -1 ? '' : 'placeholderValue'"
                        >
                          {{ from.code }}
                          <span
                            :class="{ '': true, left_formTwo: showPickerTwo }"
                          >
                            <van-icon
                              name="arrow-down"
                              size="12"
                              color="#333333"
                            />
                          </span>
                        </div>
                      </template>
                    </van-popover>
                  </div>

                  <div class="right">
                    <input
                      type="number"
                      placeholder="請輸入手機號碼"
                      v-model.trim="from.personInChargePhone"
                    />
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li>
            <div class="list">
              <div class="listLeft">驗證碼</div>
              <div class="listRight">
                <div class="listRight_sji2">
                  <div class="right">
                    <input
                      type="text"
                      placeholder="請輸入驗證碼"
                      v-model.trim="from.verifyCode"
                    />
                  </div>
                  <div
                    class="right2"
                    @click="CodeBln ? clickNumberCodeFnc() : ''"
                    v-html="codeMsg"
                  ></div>
                </div>
              </div>
            </div>
          </li>

          <li>
            <div class="list">
              <div class="listLeft">電郵</div>
              <div class="listRight" style="display: flex">
                <input
                  type="text"
                  placeholder="請輸入電郵"
                  v-model.trim="from.personInChargeEmail"
                />
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="fromButtom" @click="Frombuttom" v-if="signUp_type">
        下一步
        <!-- <img :src="require('@/assets/image/hodgepodge/tjbm.png')" alt="" /> -->
      </div>
      <!-- <div class="last-step" v-if="[2,3].includes(signUp_type)">
        <span @click="handleLastStep">返回</span>
      </div> -->
      <!-- <div class="timeUp"><div>報名已結束</div></div> -->
    </div>

    <!-- 展位 -->
    <div style="width: 100%"></div>

    <!-- 性别 -->
    <van-popup
      v-model="showPicker"
      position="bottom"
      :style="{
        'min-height': '30%',
        'max-width': '944px',
        margin: 'auto',
        right: '0',
        left: '0',
      }"
    >
      <van-picker
        show-toolbar
        :columns="sexColumns"
        @confirm="onSexConfirm"
        @cancel="showPicker = false"
        confirm-button-text="確認"
      />
    </van-popup>
    <!-- code -->
    <van-popup
      v-model="showPickerTwo"
      position="bottom"
      :style="{
        'min-height': '30%',
        'max-width': '944px',
        margin: 'auto',
        right: '0',
        left: '0',
      }"
    >
      <van-picker
        show-toolbar
        :columns="mobilePhoneColumns"
        @confirm="onPhoneConfirm"
        @cancel="showPickerTwo = false"
        confirm-button-text="確認"
      />
    </van-popup>
    <!-- 年级 -->
    <van-popup
      v-model="showPickerthree"
      position="bottom"
      :style="{
        'min-height': '30%',
        'max-width': '944px',
        margin: 'auto',
        right: '0',
        left: '0',
      }"
    >
      <van-picker
        show-toolbar
        :columns="gradeColumns"
        @confirm="ongradeConfirm"
        @cancel="showPickerthree = false"
        confirm-button-text="確認"
      />
    </van-popup>
    <!-- 年級/組別二級選擇（Vant Picker 兩列） -->
    <van-popup
      v-model="showGroupPickerPopup"
      position="bottom"
      :style="{
        'min-height': '30%',
        'max-width': '944px',
        margin: 'auto',
        right: '0',
        left: '0',
      }"
    >
      <van-picker
        show-toolbar
        :columns="groupPickerColumns"
        @change="onGroupPickerChange"
        @confirm="onGroupPickerConfirm"
        @cancel="showGroupPickerPopup = false"
        confirm-button-text="確認"
      />
    </van-popup>
    <!-- <van-popup v-model="showPickerschool2" position="bottom"
			:style="{ 'min-height': '30%','max-width':'944px','margin':'auto','right': '0','left': '0' }">
			<van-picker show-toolbar :columns="diqu" @cancel="showPickerschool2 = false" @change="onAddressChange"
				@confirm="onAddressConfirm" confirm-button-text="確認" />
		</van-popup> -->
  </section>
</template>

<script>
import headers from "@/components/header/pc_header";
import selectBox from "./components/select";
import publics from "@/mixin/public_mixin";
import home from "@/mixin/home_mixin";
import { trackMetaPixel, trackGoogleAdsConversion } from "@/utils/pixel";
export default {
  name: "signup",
  data() {
    return {
      // new
      step: 2, // 1:个人&团体  2：个人&学校
      signUp_title: "参赛方式",
      signUp_type: 2, // 1:团体  2:个人  3:学校
      showSexPopover: false,
      sexActions: [
        {
          text: "男",
          id: 0,
        },
        {
          text: "女",
          id: 1,
        },
      ],
      sexIndex: -1,
      showGradePopover: false,
      gradeActions: [
        { text: "K1", id: 0 },
        { text: "K2", id: 1 },
        { text: "K3", id: 2 },
        { text: "P1", id: 3 },
        { text: "P2", id: 4 },
        { text: "P3", id: 5 },
        { text: "P4", id: 6 },
        { text: "P5", id: 7 },
        { text: "P6", id: 8 },
        { text: "S1", id: 9 },
        { text: "S2", id: 10 },
        { text: "S3", id: 11 },
        { text: "S4", id: 12 },
        { text: "S5", id: 13 },
        { text: "S6", id: 14 },
      ],
      // 二級年級選擇狀態
      showGroupPicker: false, // 保留舊字段以避免大範圍改動（不再使用）
      groupSelectIndex: 0,
      groupSelectIndex2: -1,
      groupOptions: [
        {
          value: "特殊學校",
          label: "特殊學校",
          children: [{ value: "7", label: "閃亮組" }],
        },
        {
          value: "非華裔",
          label: "非華裔",
          children: [
            { value: "9", label: "飛躍-幼稚園組" },
            { value: "10", label: "飛躍-小學組" },
            { value: "11", label: "飛躍-中學組" },
          ],
        },
        {
          value: "幼稚園",
          label: "幼稚園",
          children: [
            { value: "1", label: "初級組K1-K2" },
            { value: "2", label: "高級組K3" },
          ],
        },
        {
          value: "小學",
          label: "小學",
          children: [
            { value: "3", label: "初級組P1-P2" },
            { value: "4", label: "中級組P3-P4" },
            { value: "5", label: "高級組P5-P6" },
          ],
        },
        {
          value: "中學組",
          label: "中學組",
          children: [{ value: "6", label: "S1-S6" }],
        },
      ],
      gradeIndex: -1,

      dqiSelectIndex: -1, //默認0
      dqiSelectIndex2: -1, //默認不選擇

      mobilePhoneActionsShow: false,
      mobilePhoneActions: [
        {
          text: "+852",
          id: 0,
        },
        {
          text: "+86",
          id: 1,
        },
      ],

      showPickerschool: false,
      diqu: [],
      cities: {},
      from: {
        username: "",
        sex: "請選擇參賽者性别", //-1 未选中  0男  1女
        code: "+852", //区号
        personInChargePhone: "", //手机号
        verifyCode: "", //手机验证码
        grade: "選擇參賽者年級", //年级
        personInChargeEmail: "", //邮件
        school_address: "", //地区
        schoolName: "", //就读学校
        agencyName: "", // 参赛学校
      },
      searchCampus: "",
      showPicker: false,
      showPickerTwo: false,
      showPickerthree: false,
      gradeColumns: [
        "選擇參賽者年級",
        "K1",
        "K2",
        "K3",
        "P1",
        "P2",
        "P3",
        "P4",
        "P5",
        "P6",
        "S1",
        "S2",
        "S3",
        "S4",
        "S5",
        "S6",
      ], //年级
      groups: [
        {
          code: 1,
          name: "幼稚園初級組（K1-K2）",
        },
        {
          code: 2,
          name: "幼稚園高級組（K3）",
        },
        {
          code: 3,
          name: "小學初級組（P1-P2）",
        },
        {
          code: 4,
          name: "小學中級組（P3-P4）",
        },
        {
          code: 5,
          name: "小學高級組（P5-P6）",
        },
        {
          code: 6,
          name: "中學組（S1-S6）",
        },
        {
          code: 7,
          name: "閃亮組",
        },
        // {
        //   code: 8,
        //   name: ''
        // },
        {
          code: 9,
          name: "非華裔-飛躍-幼稚園組（K1-K3）",
        },
        {
          code: 10,
          name: "非華裔-飛躍-小學組（P1-P6）",
        },
        {
          code: 11,
          name: "非華裔-飛躍-中學組（S1-S6）",
        },
      ],
      competitionGroup: "",
      groupId: "",

      // Vant 二列級聯選擇
      showGroupPickerPopup: false,
      groupPickerColumns: [{ values: [] }, { values: [] }],

      sexColumns: ["請選擇參賽者性别", "男", "女"],
      mobilePhoneColumns: ["+852", "+86"], //区号

      CodeBln: true,
      timer: null, //清空时间
      countdown: 60,
      codeMsg: "獲取驗證碼",

      newAddress: [], //地區
      schoolNameList: [], //提示
      diquaddRess: [], //原始
      diquaddRess2: [],
      disableWatch: false,
      competitionAccountId: "",
      schoolCode: "",
      // schoolCode: '578126',
      // competitionAccountId: 'afG6Q3',
    };
  },
  computed: {},
  mixins: [publics, home],
  components: {
    headers,
    selectBox,
  },
  watch: {
    newAddress(val) {
      if (val) {
        console.log(val);
        this.schoolNameList = [];
        this.from.schoolName = "";
        this.from.agencyName = "";
        this.searchCampus = "";
      }
    },
    searchCampus: {
      immediate: true,
      handler(val) {
        if (!this.disableWatch) {
          this.from.schoolName = "";
          this.from.agencyName = "";
          if (this.newAddress.length != 0) {
            if (val.length != 0) {
              this.getHkSchoolList(val);
            } else {
              this.schoolNameList = [];
              this.getHkSchoolList();
            }
          }
        } else {
          this.disableWatch = false;
        }
      },
    },
    showPickerschool(val) {
      console.log(val);
    },
  },
  created() {
    this.getAddressList();
    // 从地址栏中获取schoolCode参数
    const urlParams = new URLSearchParams(window.location.search);
    const schoolCode = urlParams.get("schoolCode");
    // const competitionAccountId = urlParams.get("id");
    if (schoolCode) {
      // 在本地存储schoolCode
      this.schoolCode = schoolCode;
      // this.competitionAccountId = competitionAccountId;
      sessionStorage.setItem("schoolCode", schoolCode);
      // sessionStorage.setItem("competitionAccountId", competitionAccountId);
    } else {
      this.schoolCode = sessionStorage.getItem("schoolCode") || "";
      // this.competitionAccountId =
      //   sessionStorage.getItem("competitionAccountId") || "";
    }
    if (this.schoolCode) {
      // 发请求获取对应校区
      this.getSchoolData();
    }
    // this.getSchoolData()

    // 初始化年級/組別二級選擇的列數據
    try {
      const categories = this.groupOptions.map((o) => o.label);
      const firstChildren =
        this.groupOptions[0] && this.groupOptions[0].children
          ? this.groupOptions[0].children.map((c) => c.label)
          : [];
      this.groupPickerColumns = [
        { values: categories, defaultIndex: 0 },
        { values: firstChildren, defaultIndex: 0 },
      ];
    } catch (e) {
      // 容錯：避免初始化數據異常導致頁面渲染失敗
      this.groupPickerColumns = [{ values: [] }, { values: [] }];
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    //避免元素銷毀還繼續監聽
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    goToSchoolInfo() {
      let url = "https://edu.chineserd.com/schoolInformation";
      if (window.location.host.indexOf("chineserd") == -1) {
        url = "https://edutest.chineserd.com/schoolInformation";
      }
      window.open(url, "_blank");
    },
    // 打開年級/組別二級選擇（組別專用）
    // 打開年級/組別二級選擇
    openGroupPicker() {
      // 進入時重建列數據，避免空列
      try {
        const categories = this.groupOptions.map((o) => o.label);
        const firstChildren =
          this.groupOptions[0] && this.groupOptions[0].children
            ? this.groupOptions[0].children.map((c) => c.label)
            : [];
        this.groupPickerColumns = [
          { values: categories, defaultIndex: 0 },
          { values: firstChildren, defaultIndex: 0 },
        ];
      } catch (e) {
        this.groupPickerColumns = [{ values: [] }, { values: [] }];
      }
      this.showGroupPickerPopup = true;
    },
    // 二級選擇：左列切換時更新右列
    onGroupPickerChange(picker, values, index) {
      if (index === 0) {
        const categoryLabel = values[0];
        const category = this.groupOptions.find(
          (c) => c.label === categoryLabel
        );
        const childrenLabels =
          category && category.children
            ? category.children.map((c) => c.label)
            : [];
        picker.setColumnValues(1, childrenLabels);
      }
    },
    // 確認選擇：設置 groupId、competitionGroup、顯示文本
    onGroupPickerConfirm(values) {
      const [categoryLabel, childLabel] = values;
      const category = this.groupOptions.find((c) => c.label === categoryLabel);
      if (category && category.children && childLabel) {
        const child = category.children.find((x) => x.label === childLabel);

        if (child) {
          this.groupId = child.value;
          this.competitionGroup = child.label;
        }
      }
      this.showGroupPickerPopup = false;
    },
    getSchoolData() {
      let schoolNo =
        this.schoolCode.charAt(0) === "S"
          ? this.schoolCode.slice(1)
          : this.schoolCode;
      const params = {
        schoolNo: schoolNo,
      };
      this.$axios({
        url: this.$api.getSchoolByCode,
        method: "get",
        params: params,
      }).then((response) => {
        const { data } = response.data;
        if (response.data.code == 0) {
          const { schoolRegion, schoolRegion1, schoolName } = data;
          this.newAddress[0] = schoolRegion;
          this.newAddress[1] = schoolRegion1;
          // this.schoolNameList = [{ schoolName }]
          this.disableWatch = true;
          this.from.schoolName = schoolName;
          this.searchCampus = schoolName;
        }
      });
    },
    handleLastStep() {
      this.signUp_type = null;
      this.step = 2;
    },
    handleStep(val) {
      // 1:团体  2:个人  3:学校  null:个人&学校
      if (val) {
        this.signUp_type = val;
        this.signUp_title = "在線報名";
      } else {
        this.step = 2;
        this.signUp_title = "参赛方式";
        this.signUp_type = null;
      }
    },
    whatapp() {
      this.home_mdevInit();
      window.open(this.whatUrl, "_blank");
    },
    onmobilePhoneSelect(action) {
      this.from.code = action.text;
    },
    isNumber(value) {
      return typeof value === "number";
    },
    // 電郵驗證
    validator_email(val) {
      const email = val.trim();
      return /^[A-Za-z0-9]+([_\-\.][A-Za-z0-9]+)*@([A-Za-z0-9\-\_]+\.)+[A-Za-z]{2,6}$/.test(
        email
      );
    },
    toggleElement() {
      this.showPickerschool = !this.showPickerschool;
    },
    handleClickOutside(event) {
      if (
        this.$refs.elementDQ &&
        !this.$refs.elementDQ.contains(event.target)
      ) {
        this.showPickerschool = false;
      }
      if (
        this.$refs.groupPickerRef &&
        !this.$refs.groupPickerRef.contains(event.target)
      ) {
        this.showGroupPicker = false;
      }
    },
    onselectDqBut(event, index) {
      this.dqiSelectIndex = index;
      this.diquaddRess2 = event.data;
      this.dqiSelectIndex2 = 0;
      this.newAddress[0] = event.title;
      this.newAddress[1] = event.data[0];
    },
    onselectDqBut2(event, index) {
      if (this.dqiSelectIndex != -1) {
        this.dqiSelectIndex2 = index;
        this.newAddress[1] = event;
      } else {
        this.$toast("請先選擇區域");
      }
    },
    onSexSelect(action) {
      this.sexIndex = action.id;
      this.from.sex = action.text;
    },
    // 舊二級年級選擇方法保留（不再使用），避免其他引用報錯
    toggleGroupPicker() {},
    onSelectGroupFirst() {},
    onSelectGroupSecond() {},

    zhiyin(e) {
      this.disableWatch = true;
      this.searchCampus = e.schoolName;
      this.$nextTick(() => {
        this.from.schoolName = e.schoolName;
        this.from.agencyName = e.schoolName;
        this.schoolNameList = [];
      });
    },
    onAddressChange(picker, value, index) {
      picker.setColumnValues(1, this.cities[value[0]]);
      this.newAddress = value;
    },
    onAddressConfirm(e) {
      console.log(e);
      this.newAddress = e;
      this.showPickerschool = false;
    },
    getAddressList() {
      this.$axios
        .get(this.$api.getHkSchoolRegion)
        .then((res) => {
          // console.log(res)
          if (res.data.code == 0) {
            let data = res.data.data;
            this.diquaddRess = data;
            this.diquaddRess2 = data[0].data;

            // console.log(this.diquaddRess2)
            const cities = data.reduce((result, { title, data }) => {
              result[title] = data;
              return result;
            }, {});
            // console.log(cities)
            this.cities = cities;
            this.diqu = [
              {
                values: Object.keys(cities),
              },
              {
                values: cities["港島區域"],
              },
            ];
          }
        })
        .catch((res) => {
          console.log("失败", res);
        });
    },
    getHkSchoolList(e) {
      let params = {
        schoolRegion: this.newAddress[0],
        schoolRegion1: this.newAddress[1],
        schoolName: e,
      };
      this.$axios({
        url: this.$api.getHkSchool,
        method: "get",
        params: params,
      })
        .then((res) => {
          // console.log(res)
          let data = res.data.rows;
          if (res.data.code == 0) {
            this.schoolNameList = [];
            this.schoolNameList = data;
          }
        })
        .catch((res) => {
          console.log("失败", res);
        });
    },
    validator_phone(val) {
      const phone = val;
      return /^[0-9]*$/.test(phone);
    },
    // 验证码
    clickNumberCodeFnc() {
      let { code, personInChargePhone } = this.from;
      // console.log(code, personInChargePhone)
      if (personInChargePhone == null || personInChargePhone == "") {
        this.$toast.fail("請檢查您的手機號");
        return;
      }

      if (!this.validator_phone(personInChargePhone)) {
        this.$toast("手機號格式有誤 !");
        return;
      }

      const phoneList = [];
      let prefix = code;

      // if (prefix == "+86") {
      //   phoneList.push(personInChargePhone);
      // } else {
      //   phoneList.push(prefix + "-" + personInChargePhone);
      // }
      phoneList.push(prefix + "-" + personInChargePhone);
      const params = {
        appType: 12,
        verifyType: 9,
        phoneList,
        smsTemplateType: 10,
        signType: 1,
      };

      this.$toast.loading({
        message: "正在獲取中...",
        forbidClick: true,
        duration: 0,
      });
      let sendUrl = this.$api.sendSmsForSecondCup;
      if (this.signUp_type != 2) {
        // 团体
        sendUrl = this.$api.sendSmsForGroup;
      }

      this.$axios({
        url: sendUrl,
        method: "post",
        data: params,
      })
        .then((response) => {
          console.log("response", response);
          if (response.data.code == 0) {
            this.$toast.clear();
            this.$toast.success("驗證碼获取成功");
            let that = this;
            clearInterval(that.timeIntinvel);
            that.CodeBln = false;
            let index = 60;

            that.timeIntinvel = setInterval(() => {
              index--;
              if (index <= 0) {
                index = 0;
                that.CodeBln = true;
                that.codeMsg = "獲取驗證碼";
              } else {
                that.codeMsg = `${index}S`;
              }
            }, 1000);
          } else {
            this.$toast.fail("驗證碼获取失败");
          }
        })
        .catch((error) => {
          //请求失败
          this.$toast.clear();
          this.$toast.fail("error");
          console.log(error);
        });
    },
    getQueryString: function (name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    // 表單
    Frombuttom() {
      console.log(this.from, "from");
      const prefix = this.from.code.replace("+", "");
      if ([1, 3].includes(this.signUp_type)) {
        let {
          agencyName,
          personInChargeName,
          personInChargePhone,
          verifyCode,
          personInChargeEmail,
        } = this.from;
        if (this.signUp_type == 3 && this.newAddress.length == 0) {
          this.$toast.fail("選擇學校所在地區");
          return;
        }
        if (agencyName == "" || agencyName == null) {
          if (this.signUp_type == 1) {
            this.$toast.fail("請檢查参赛團體/機構");
          } else {
            this.$toast.fail("請檢查参赛學校");
          }
          return;
        }
        if (personInChargeName == "" || personInChargeName == null) {
          this.$toast.fail("請檢查聯絡人姓名");
          return;
        }
        if (personInChargePhone == "" || personInChargePhone == null) {
          this.$toast.fail("請輸入聯絡人電話");
          return;
        }

        if (!this.validator_phone(personInChargePhone)) {
          this.$toast("手機號格式有誤 !");
          return;
        }
        if (verifyCode == "" || verifyCode == null) {
          this.$toast.fail("請輸入驗證碼");
          return;
        }

        if (personInChargeEmail == "" || personInChargeEmail == null) {
          this.$toast.fail("請輸入電郵");
          return;
        }

        if (!this.validator_email(personInChargeEmail)) {
          this.$toast("電郵格式有誤 !");
          return;
        }
        let agencyArea;
        let agencyType;
        let agencyName_;
        let schoolName;
        if (this.signUp_type == 3) {
          // 学校
          agencyArea = this.newAddress[0] + ">" + this.newAddress[1];
          agencyType = 1;
          agencyName_ = undefined;
          schoolName = agencyName;
        } else {
          // 团体
          agencyArea = undefined;
          agencyType = 0;
          schoolName = undefined;
          agencyName_ = agencyName;
        }
        const params = {
          agencyName: agencyName_, // 机构名
          schoolName, // 学校名
          personInChargeName,
          personInChargePhone: prefix + "-" + personInChargePhone,
          verifyCode,
          personInChargeEmail,
          agencyArea,
          agencyType, // 0:团体;1:个人
        };
        this.$toast.loading({
          message: "正在提交中...",
          forbidClick: true,
          duration: 0,
        });
        this.$axios({
          url: this.$api.fromSave,
          method: "post",
          data: params,
        })
          .then((response) => {
            console.log(response);
            if (response.data.code == 0) {
              this.$toast.success("提交成功");
              // console.log(response.data, 'data')
              const {
                agency,
                currentSchool,
                competitionAccountId,
                studentRegion,
              } = response.data;
              // 新窗口打开朗诵管理后台
              if (agencyType === 0) {
                // 团体
                const params = `agency=${agency}&competitionAccountId=${competitionAccountId}&id=${response.data["competition-token"]}`;
                var url = "http://hk.zhixin2018.cn/team/entry-list?" + params;
                window.open(url, "_blank");
              } else {
                const params = `currentSchool=${currentSchool}&studentRegion=${studentRegion}&competitionAccountId=${competitionAccountId}&id=${response.data["competition-token"]}`;
                var url =
                  "http://hk.zhixin2018.cn/personal/entry-list?" + params;
                window.open(url, "_blank");
              }
              this.$router.replace("/successful");
            } else {
              this.$toast.fail(response.data.msg);
            }
          })
          .catch((error) => {
            //请求失败
            this.$toast.clear();
            this.$toast.fail("error");
            console.log(error);
          });
      } else if (this.signUp_type == 2) {
        console.log("个人报名", this.from, this.competitionGroup, this.groupId);

        const {
          username,
          code,
          personInChargePhone,
          verifyCode,
          personInChargeEmail,
          sex,
          grade,
          schoolName,
          studentCode,
          password,
        } = this.from;
        if (username == "" || username == null) {
          this.$toast.fail("請檢查參賽者姓名");
          return;
        }
        if (personInChargePhone == "" || personInChargePhone == null) {
          this.$toast.fail("請輸入手機號");
          return;
        }

        if (!this.validator_phone(personInChargePhone)) {
          this.$toast("手機號格式有誤 !");
          return;
        }
        if (verifyCode == "" || verifyCode == null) {
          this.$toast.fail("請輸入驗證碼");
          return;
        }
        if (personInChargeEmail == "" || personInChargeEmail == null) {
          this.$toast.fail("請輸入電郵");
          return;
        }
        if (!this.validator_email(personInChargeEmail)) {
          this.$toast("電郵格式有誤 !");
          return;
        }

        if (sex == "請選擇參賽者性别" || sex == -1) {
          this.$toast.fail("請選擇參賽者性别");
          return;
        }

        if (grade == "選擇參賽者年級" || grade == null) {
          this.$toast.fail("選擇參賽者年級");
          return;
        }
        console.log(this.groupId, "groupId");

        if (
          this.groupId == "選擇參賽者組別" ||
          this.groupId == null ||
          this.groupId == ""
        ) {
          this.$toast.fail("選擇參賽者組別");
          return;
        }
        if (this.newAddress.length == 0) {
          this.$toast.fail("選擇學校地區");
          return;
        }

        if (schoolName == "" || schoolName == null) {
          this.$toast.fail("請檢查就讀學校");
          return;
        }

        // if (this.schoolCode) {
        //   if (!studentCode) {
        //     this.$toast.fail("請輸入學生編號");
        //     return;
        //   }
        //   if (!password) {
        //     this.$toast.fail("請輸入登錄密碼");
        //     return;
        //   }
        // }
        const params = {
          studentName: username,
          sex,
          phone: personInChargePhone,
          grade,
          prefix: code.replace(/\+/g, ""),
          email: personInChargeEmail,
          verifyCode,
          studentRegion: this.newAddress[0] + ">" + this.newAddress[1],
          currentSchool: schoolName,
          competitionGroup: this.competitionGroup,
          groupId: this.groupId,
          studentCode,
          password,
          schoolCode: this.schoolCode,
          // competitionAccountId: this.competitionAccountId,
          competitionType: 8,
          platform: !localStorage.getItem("c")
            ? "PC"
            : localStorage.getItem("c"),
        };
        console.log("提交", params);
        this.$toast.loading({
          message: "正在提交中...",
          forbidClick: true,
          duration: 0,
        });
        // this.$api.signUpByStudentCode 学号注册
        // this.$api.fromSaveSingle 普通个人注册
        this.$axios({
          url: this.schoolCode
            ? this.$api.signUpByStudentCode
            : this.$api.fromSaveSingle,
          method: "post",
          data: params,
        })
          .then((response) => {
            // console.log(response)
            if (response.data.code == 0) {
              // 根据 platform 参数触发不同埋点
              const platform = localStorage.getItem("c") || "PC";
              if (platform === "100") {
                // Meta Pixel
                trackMetaPixel('CompleteRegistration');
              } else if (platform === "200") {
                // Google Ads 转化事件
                trackGoogleAdsConversion('AW-10986705020/b2mfCIGLta0ZEPyg7_Yo');
              }
              this.$toast.success("提交成功");
              this.$router.replace("/successful");
              sessionStorage.setItem("schoolCode", "");
              // sessionStorage.setItem("competitionAccountId", "");
            } else {
              this.$toast.fail(response.data.msg);
            }
          })
          .catch((error) => {
            //请求失败
            this.$toast.clear();
            this.$toast.fail("error");
            console.log(error);
          });
      }
      // this.$router.push("/successful");
    },
    onSexConfirm(e) {
      console.log(e);
      this.from.sex = e;
      this.showPicker = false;
    },
    sexBut() {
      this.showPicker = true;
    },
    schoolBut() {
      this.showPickerthree = true;
    },
    pickerPhoneBut() {
      this.showPickerTwo = true;
    },
    onPhoneConfirm(e) {
      console.log(e);
      this.from.code = e;
      this.showPickerTwo = false;
    },
    ongradeConfirm(e) {
      console.log(e);
      this.from.grade = e;
      this.showPickerthree = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.views {
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  background: #ff782f;

  .posters {
    width: 100%;
    display: flex;
    position: relative;

    img {
      width: 100%;
    }

    .posters_ewm {
      position: absolute;
      width: 1024px;
      right: 20px;
      bottom: 20px;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: right;

      .ewm {
        width: 161px;
        min-height: 189px;
        background: rgba(255, 255, 255, 0.63);
        border-radius: 16px 16px 16px 16px;
        padding: 8px;
        box-sizing: border-box;
        cursor: pointer;

        .ewm2 {
          width: 100%;
          height: 100%;
          padding: 6px;
          background: #fdcf1d;
          border-radius: 12px 12px 12px 12px;
          box-sizing: border-box;

          .ewm3 {
            width: 132px;
            height: 132px;
            background: #ffffff;
            border-radius: 8px 8px 8px 8px;
            margin-bottom: 6px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          .ewm3_value {
            width: 100%;
            height: 40px;
            font-size: 16px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #323232;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            background: url("~@/assets/image/icon/ewmbut.png") no-repeat;
            background-size: 100% 100%;
            box-shadow: inset 0px 1px 4px 0px rgba(234, 138, 7, 0.48),
              inset 0px -5px 3px 0px rgba(255, 227, 129, 0.57);
            vertical-align: middle; /* 将文本和图片垂直居中对齐 */

            img {
              width: 20px;
              height: 20px;
              margin-right: 4px;
              vertical-align: middle; /* 将图片和文本垂直居中对齐 */
            }
          }
        }
      }
    }
  }

  .content {
    width: 100%;
    max-width: 944px;
    margin: auto;
    margin-top: 83px;
    margin-bottom: 30px;

    // min-height: 795px;
    background: #ffffff;
    box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.05);
    border-radius: 16px;

    padding-bottom: 26px;

    .contentFrom_titleBox {
      width: 100%;
      height: 52px;
      position: relative;

      .contentFrom_title {
        width: 265px;
        height: 52px;
        margin: auto;
        border-radius: 9px;
        background: url("~@/assets/image/icon/titlebg.png") no-repeat;
        background-size: 100% 100%;
        font-size: 20px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 23px;
        line-height: 52px;
        position: absolute;
        top: -47%;
        left: 0;
        right: 0;
        margin: auto;

        text-shadow: 1.5px 1.5px 0 #ff782f, -1.5px 1.5px 0 #ff782f,
          1.5px -1.5px 0 #ff782f, -1.5px -1.5px 0 #ff782f;
      }
    }
    .type_container {
      // border: 1px solid red;
      width: 70%;
      margin: 40px auto 80px auto;
      display: flex;
      justify-content: space-around;
      .competition_type {
        cursor: pointer;
        img {
          margin-bottom: 20px;
          // border: 1px solid red;
          width: 120px;
        }
      }
    }

    .listRight_sji {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      text-align: right;
      justify-content: flex-end;
      color: #cccccc;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;

      .left {
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        height: 100%;
        display: flex;
        align-items: center;
        position: relative;
        padding-right: 0.32rem;
        box-sizing: border-box;

        span:nth-child(1) {
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          margin-right: 10px;
        }

        .left_formTwo {
          transform: rotate(180deg);
        }
      }

      .left:after {
        content: " ";
        width: 1px;
        height: 20px;
        background: #cccccc;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
      }

      .right {
        padding-left: 30px;
        box-sizing: border-box;
        width: 150px;
        height: 100%;
      }
    }

    .contentFrom_uls {
      padding: 30px 158px 0 158px;
      box-sizing: border-box;

      ul {
        width: 100%;
        background: #ffffff;

        li:last-child {
          border-bottom: none !important;
        }

        li {
          width: 100%;
          border-bottom: 1px solid #f2f2f2;
          .list {
            width: 100%;
            height: 68px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .listLeft {
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }

            .listPan {
              position: relative;

              .posText {
                position: absolute;
                height: 1px;
                bottom: 0;
                right: 0;
                min-width: 50%;
                margin: auto;
                z-index: 1;

                ul {
                  width: 100%;
                  box-sizing: 0 1px 3px rgba(31, 35, 40, 0.12),
                    0 8px 24px rgba(66, 74, 83, 0.12);
                  border: 2px solid #f2f2f2;
                  max-height: 270px;
                  overflow-y: auto;

                  li {
                    height: 30px;
                    // line-height: 30px;
                    text-align: left;
                    padding: 10px;
                    box-sizing: border-box;
                    cursor: pointer;
                  }

                  li:hover {
                    background: #52a1ff;
                    color: #ffffff;
                  }
                }
              }
            }

            .listRight {
              width: 70%;
              height: 100%;
              position: relative;

              input {
                width: 100%;
                height: 100%;
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #000000;
                border: none;
                text-align: right;
                background: none;
                padding: 0;
                box-sizing: border-box;
              }
              /* 隐藏步进器 */
              input[type="number"]::-webkit-inner-spin-button,
              input[type="number"]::-webkit-outer-spin-button {
                -webkit-appearance: none;
                margin: 0;
              }

              input[type="number"] {
                appearance: none;
                -moz-appearance: textfield; /* Firefox */
              }

              input::-webkit-input-placeholder {
                color: #cccccc;
              }

              /* 使用webkit内核的浏览器 */
              input:-moz-placeholder {
                color: #cccccc;
              }

              /* Firefox版本4-18 */
              input::-moz-placeholder {
                color: #cccccc;
              }

              /* Firefox版本19+ */
              input:-ms-input-placeholder {
                color: #cccccc;
              }

              /* IE浏览器 */

              .listRight_xuan {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                text-align: right;
                justify-content: flex-end;
                color: #cccccc;
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                cursor: pointer;

                .placeholderValue {
                  color: #000000 !important;
                }

                .listRight_icon {
                  margin-left: 10px;
                }

                .listRight_icontransform {
                  transform: rotate(180deg);
                }
              }
              .listRight_xuan_2 {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                text-align: right;
                justify-content: flex-end;
                color: #cccccc;
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                cursor: pointer;

                .placeholderValue {
                  color: #000000 !important;
                  // 鼠标变为不可点击
                  cursor: not-allowed;
                }

                .listRight_icon {
                  margin-left: 10px;
                }

                .listRight_icontransform {
                  transform: rotate(180deg);
                }
              }

              .listRight_sji2 {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                text-align: right;
                justify-content: flex-end;
                color: #cccccc;
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;

                .right {
                  font-size: 14px;
                  font-family: PingFang SC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #333333;
                  height: 100%;
                  display: flex;
                  align-items: center;
                  position: relative;
                  padding-right: 30px;
                  box-sizing: border-box;
                }

                .right2 {
                  font-size: 14px;
                  font-family: PingFang SC-Semibold, PingFang SC;
                  font-weight: 600;
                  color: #52a1ff;
                  display: flex;
                  align-items: right;
                  width: 79px;
                  justify-content: right;
                  cursor: pointer;
                }

                .right:after {
                  content: " ";
                  width: 1px;
                  height: 20px;
                  background: #cccccc;
                  position: absolute;
                  top: 0;
                  right: 0;
                  bottom: 0;
                  margin: auto;
                }
              }

              .selectBox {
                position: absolute;
                top: 100%;
                right: 0;
                min-width: 200px;
                min-height: 20px;
                background: #ffffff;
                z-index: 99;
                padding: 10px;
                border-radius: 10px;
                box-shadow: 0 2px 12px rgba(50, 50, 51, 0.12);
                display: flex;

                .selectBoxLeft {
                  width: 49%;
                  min-height: 30px;

                  .selectBox_uls {
                    width: 100%;
                    height: 100%;
                    overflow-y: hidden;
                    font-size: 14px;

                    .selectBox_lis {
                      width: 100%;
                      height: 30px;
                      display: flex;
                      align-items: center;
                      white-space: nowrap;
                    }
                  }
                }

                .selectBox_xian {
                  width: 1px;
                  background: #cccccc;
                  border-radius: 10px;
                }

                .selectBoxRight {
                  width: 49%;
                  min-height: 30px;
                  max-height: 300px;
                  margin-left: 10px;

                  .selectBox_uls {
                    width: 100%;
                    height: 100%;
                    font-size: 14px;
                    overflow-y: hidden;

                    .selectBox_lis {
                      width: 100%;
                      height: 30px;
                      display: flex;
                      align-items: center;
                      white-space: nowrap;
                    }
                  }
                }

                .selectBox_lis {
                  cursor: pointer;
                }

                .select_select {
                  color: red;
                }
              }
            }
            .beizhu {
              width: 100%;
              font-size: 13px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #e80202;
              margin-top: 8px;
              text-align: left;
              padding-bottom: 9px;
              box-sizing: border-box;
              margin-top: -10px;
            }
          }

          .list2 {
            width: 100%;

            .list2_uls {
              width: 100%;
              height: 68px;
              display: flex;
              align-items: center;
              justify-content: space-between;

              .listLeft {
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
              }

              .listRight {
                width: 70%;
                height: 100%;
                display: flex;

                input {
                  width: 100%;
                  height: 100%;
                  font-size: 14px;
                  font-family: PingFang SC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #000000;
                  border: none;
                  text-align: right;
                  background: none;
                  padding: 0;
                  box-sizing: border-box;
                }

                /* 隐藏步进器 */
                input[type="number"]::-webkit-inner-spin-button,
                input[type="number"]::-webkit-outer-spin-button {
                  -webkit-appearance: none;
                  margin: 0;
                }

                input[type="number"] {
                  appearance: none;
                  -moz-appearance: textfield; /* Firefox */
                }

                input::-webkit-input-placeholder {
                  color: #cccccc;
                }

                /* 使用webkit内核的浏览器 */
                input:-moz-placeholder {
                  color: #cccccc;
                }

                /* Firefox版本4-18 */
                input::-moz-placeholder {
                  color: #cccccc;
                }

                /* Firefox版本19+ */
                input:-ms-input-placeholder {
                  color: #cccccc;
                }

                /* IE浏览器 */

                .listRight_xuan {
                  width: 100%;
                  height: 100%;
                  display: flex;
                  align-items: center;
                  text-align: right;
                  justify-content: flex-end;
                  color: #cccccc;
                  font-size: 14px;
                  font-family: PingFang SC-Regular, PingFang SC;
                  font-weight: 400;
                  cursor: pointer;

                  .placeholderValue {
                    color: #000000 !important;
                  }

                  .listRight_icon {
                    margin-left: 10px;
                  }

                  .listRight_icontransform {
                    transform: rotate(180deg);
                  }
                }
              }
            }

            .beizhu {
              width: 100%;
              font-size: 13px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #e80202;
              margin-top: 8px;
              text-align: left;
              padding-bottom: 9px;
              box-sizing: border-box;
              margin-top: -10px;
            }
          }
        }
      }

      .uls_beizhu {
        font-size: 13px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #e80202;
        line-height: 18px;
        text-align: left;
      }

      .school-tip {
        margin-top: 12px;
        font-size: 13px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        text-align: left;

        &__link {
          color: #ff782f;
          text-decoration: underline;
          cursor: pointer;

          &:hover {
            opacity: 0.9;
          }
        }
      }
    }

    .promptInputValue {
      min-width: 100px;
      height: 68px;
      line-height: 68px;
      // padding-left: 13px;
      // box-sizing: border-box;
      // border: none;
      // background: #f5f5f5;
      // border-radius: 6px 6px 6px 6px;
      // font-size: 12px;
      // font-family: PingFang SC-Regular, PingFang SC;
    }

    .fromButtom {
      width: 360px;
      height: 50px;
      line-height: 50px;
      font-weight: 600;
      text-align: center;
      margin: 0 auto;
      margin-top: 32px;
      color: #ffffff;
      background-color: rgb(255, 120, 47);
      border-radius: 25px;
      letter-spacing: 2px;
      font-size: 18px;

      &:hover {
        cursor: pointer;
        opacity: 0.9;
        transition: background-color 0.3s ease;
      }
    }
    .last-step {
      margin: 20px 0;
      font-size: 14px;
      letter-spacing: 2px;
      color: rgb(255, 120, 47);
      span {
        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
    .timeUp {
      width: 300px;
      height: 48px;
      margin: auto;
      margin-top: 32px;
      background: #d0d0d0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      cursor: not-allowed;
      font-size: 20px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 20px;
      box-shadow: 0px 4px 9px 0px rgba(208, 208, 208, 0.4);
      border-radius: 24px;
    }
  }
}

.beizhu_2 {
  width: 100%;
  font-size: 13px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff782f;
  margin-top: 5px;
  text-align: right;
  padding-bottom: 9px;
  box-sizing: border-box;
  margin-top: -10px;
}
.views::-webkit-scrollbar {
  display: none;
}
</style>
